import { cn } from "@/lib/utils";
import { useSelector } from "react-redux";

import { extractColors } from "../../../../functions/extractCardColors";
import { getVersionAssetsSelector } from "../../../../redux/loadedContent/loadedContentSlice";

type Props = {
  metalId: number;
  versionId: number;
  playerUrl: string;
  playerName?: string;
  isSelecting?: boolean;
};

export const SquarePlayer = ({
  metalId,
  versionId,
  playerName,
  playerUrl,
  isSelecting,
}: Props) => {
  const versionAssets = useSelector(getVersionAssetsSelector);
  const { cardUrl } = extractColors({
    versionAssets,
    versionId,
    metalId,
    isSquare: true,
  });

  return (
    <article
      className={cn(
        "relative w-9 h-9 mobile:w-14 mobile:h-14 overflow-hidden rounded shrink-0",
      )}
    >
      <img src={cardUrl} className="absolute" alt={playerName} />
      <img
        src={playerUrl}
        style={{
          background: isSelecting
            ? "linear-gradient(0deg, rgba(255, 255, 255, 0.30) 0%, rgba(255, 255, 255, 0.30) 100%)"
            : "none",
        }}
        className="absolute"
        alt={playerName}
      />
    </article>
  );
};
